import {
  Progress,
  ProgressLabel,
  ProgressValue,
} from '@/components/ui/progress';

type ProgressToastContentProps = {
  progress: number;
  label: string;
};

export function ProgressToastContent({
  progress,
  label,
}: ProgressToastContentProps) {
  return (
    <Progress value={progress} className="mt-1 min-w-56 gap-2">
      <ProgressLabel>{label}</ProgressLabel>
      <ProgressValue />
    </Progress>
  );
}
